export default "__VITE_ASSET__DidgNu4r__"